<template>
  <div class="form-group">
    <label class="active-select px-2" for="">{{ label }}</label>
    <div class="device-select mb-2" v-click-outside="handleHide">
      <div class="position-relative">
        <input
          type="text"
          @input="$emit('doSearch', $event)"
          class="font-16 device-select"
          :placeholder="placeholder"
          style="height: 2.3rem;width: 100%;padding-left: 40px;"
          @focus="handleFocus"
        />
        <i
          class="fas fa-search fa-lg position-absolute"
          style="top: 12px;left: 10px;color: #B7C3CD;"
        ></i>
      </div>
      <div
        class="dropdown"
        :style="data.length > 2 && 'overflow-y:auto'"
        v-show="show"
      >
        <div v-if="data.length > 0">
          <div class="check-devices d-flex mb-2">
            <input
              type="checkbox"
              :checked="isSelectAll"
              name="selected-device"
              @click="isSelectAll ? deSelectAll() : selectAll()"
              :id="label.toLowerCase().replace(' ', '-')"
              class="cursor-pointer "
            />
            <label
              :for="label.toLowerCase().replace(' ', '-')"
              class=" gray4 mb-0 font-16 cursor-pointer"
              style="margin-left: 0.7rem;font-weight: 100;"
              >{{ !isSelectAll ? $t("sel_all") : $t("desel_all") }}</label
            >
          </div>
          <div
            class="check-devices d-flex mb-2"
            v-for="(item, i) in data"
            :key="i"
          >
            <input
              type="checkbox"
              :checked="isItemChecked(item)"
              :id="item.id || item.name"
              name="selected-device"
              @click="$emit('checkClick', item)"
              class="cursor-pointer checkbox"
            />
            <label
              :for="item.id"
              class=" gray4 mb-0 font-16 cursor-pointer"
              style="margin-left: 0.7rem;font-weight: 100;"
              >{{ item.name }}</label
            >
          </div>
        </div>
        <div v-else>
          <h4 class="text-center mb-0 gray4">
            {{ $t("no_result_found") }}
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComboBox",
  data() {
    return {
      key: "",
      show: false,
    };
  },
  props: {
    data: Array,
    isSelectAll: Boolean,
    isItemChecked: Function,
    deSelectAll: Function,
    selectAll: Function,
    placeholder: {
      type: String,
      default: function() {
        return this.$t("search");
      },
    },
    label: {
      type: String,
      default: function() {
        return this.$t("search");
      },
    },
  },
  methods: {
    handleHide() {
      this.show = false;
    },
    handleFocus() {
      this.show = true;
    },
  },
};
</script>

<style>
.dropdown {
  max-height: 10.3rem;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);
  padding: 12px 16px 16px 16px;

  position: absolute;
  width: 100%;
  z-index: 300;
}
</style>
